import { render } from "./HomeMyDataLanguage.vue?vue&type=template&id=65e39574"
import script from "./HomeMyDataLanguage.vue?vue&type=script&lang=js"
export * from "./HomeMyDataLanguage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__